var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "memberCotnainer" },
    [
      _vm._l(_vm.groupMembers, function(item) {
        return _c("div", { key: item.Key, staticClass: "memberInfo" }, [
          _c("img", {
            staticClass: "memberHead",
            attrs: { src: _vm.baseUrl + item.Member.HeadImage }
          }),
          item.IsManager
            ? _c("div", { staticClass: "name focus" }, [
                _vm._v(_vm._s(item.Member.RealName))
              ])
            : _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(item.Member.RealName))
              ])
        ])
      }),
      _c(
        "span",
        { staticClass: "icon el-icon-plus", staticStyle: { color: "red" } },
        [_vm._v(_vm._s(_vm.groupMembers.length))]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }